import { useCurrentUser } from '@src/entities/User/ui/hooks/useCurrentUser';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { NavMenuPrimitives } from '@uhg-abyss/web/ui/NavMenu';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';

import { MenuItem } from '../MenuItem';
import { Styles as SubMenuStyles } from '../SubMenu/includes/styles';

/**
 * UserMenu
 *
 * Provides a menu with user-related actions.
 *
 * @returns {Element}
 * @constructor
 */
export function UserMenu() {
  const { currentRole, displayName, emailAddress, msid } = useCurrentUser();

  return (
    <ErrorHandler location="src/layouts/Application/sections/Header/components/Navigation/components/UserMenu/UserMenu.jsx">
      <NavMenuPrimitives.Item>
        <NavMenuPrimitives.Trigger variant="inverted">
          <MenuItem iconName="account_box" title={displayName} />
        </NavMenuPrimitives.Trigger>
        <NavMenuPrimitives.Content>
          <SubMenuStyles>
            <NavMenuPrimitives.Columns>
              <NavMenuPrimitives.Column>
                <NavMenuPrimitives.Item>
                  <Text css={{ wordBreak: 'break-all' }}>
                    <Layout.Group>
                      <div style={{ whiteSpace: 'nowrap' }}>
                        <strong>MSID:</strong>
                      </div>
                      <div>{msid}</div>
                    </Layout.Group>
                  </Text>
                </NavMenuPrimitives.Item>
                <NavMenuPrimitives.Item>
                  <Text css={{ wordBreak: 'break-all' }}>
                    <Layout.Group>
                      <div style={{ whiteSpace: 'nowrap' }}>
                        <strong>Email:</strong>
                      </div>
                      <div>{emailAddress}</div>
                    </Layout.Group>
                  </Text>
                </NavMenuPrimitives.Item>
                <NavMenuPrimitives.Item>
                  <Text>
                    <Layout.Group>
                      <strong>Permissions:</strong>
                      <Badge
                        ariaText="information"
                        icon={<IconSymbol color="$info1" icon="info" size="$sm" variant="outlined" />}
                        variant="info"
                      >
                        {currentRole} Access
                      </Badge>
                    </Layout.Group>
                  </Text>
                </NavMenuPrimitives.Item>
                <NavMenuPrimitives.MenuItem href="/logout" title="Logout" />
              </NavMenuPrimitives.Column>
            </NavMenuPrimitives.Columns>
          </SubMenuStyles>
        </NavMenuPrimitives.Content>
      </NavMenuPrimitives.Item>
    </ErrorHandler>
  );
}
